import { SimpleNewsItem } from '../../../ts/mapper/simpleNewsItemMapper'

export interface CombinedNewsFeed {
    items: SimpleNewsItem[]
    page: number
    totalPages: number
    radiusExpansion?: string
    radiusExpansionBy?: string
    federalStateName?: string
    isLastPage: boolean
}

export interface CombinedNewsFeedRequest {
    page: number
    locationId: string
}

export enum FilterClicks {
    FILTER_OPEN = 'filter_open',
    FILTER_CLOSE = 'filter_close',
}
